(function () {
  'use strict';

  /*
   * Registre interne des correspondances controlees par l'equipe.
   * Ne jamais y enregistrer un VIN, une immatriculation ou une donnee client.
   * Chaque entree doit reposer sur des donnees techniques concordantes et un
   * produit existant dans le catalogue Shopify.
   */
  window.ID24VerifiedFitments = [
    {
      market: 'FR',
      cnit: 'M10CTRVP005Z587',
      tvv: '3D9HC81S',
      make: 'CITROEN',
      model: 'C4PICASSO',
      engine: '16HDI',
      engineCode: '9HC',
      displacementCc: '1560',
      powerKw: '85',
      fuel: 'DIESEL',
      productHandles: ['9674973080'],
      verificationLabel: 'Correspondance validee avec les donnees techniques de la carte grise'
    }
  ];
}());
